<template>
  <div class="mask overlay-fade">
    <div class="bg-white flex flex-column tutorial-frame">
      <img src="@/assets/img/tutorial/import_tutorial_back.png" alt="import_tutorial" />
      <div>
        <div class="title">
          {{ isNovelCreated ? $t("homePage.importTutorial.titleWithWork") : $t("homePage.importTutorial.titleNoWork") }}
        </div>
        <div class="content">
          {{
            isNovelCreated
              ? $t("homePage.importTutorial.contentPrefixWithWork")
              : $t("homePage.importTutorial.contentPrefixNoWork")
          }}<span class="yellow">{{ $t("homePage.importTutorial.contentHighlight") }}</span
          >{{ $t("homePage.importTutorial.contentSuffix") }}
        </div>
        <div class="import">
          <button class="import-button" @click="importClicked">{{ $t("homePage.importTutorial.importButton") }}</button>
        </div>
        <div class="skip" @click="skipClicked">{{ $t("homePage.importTutorial.skip") }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

interface Methods {
  importClicked: () => void;
  skipClicked: () => void;
}

interface Props {
  close?: () => void;
  isNovelCreated: boolean;
}

export default Vue.extend<{}, Methods, {}, Props>({
  methods: {
    importClicked() {
      const { close } = this;
      close();
      this.$emit("onboarding-import-clicked");
    },
    skipClicked() {
      const { close } = this;
      close();
      this.$emit("onboarding-skip-clicked");
    },
  },
  props: {
    close: Function,
    isNovelCreated: Boolean,
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  z-index: 9000;
  align-items: center;
  justify-content: center;
  background-color: var(--color-overlay);
}

.tutorial-frame {
  width: 400px;
  max-width: 100%;
  border-radius: var(--radius-sm);
  .title {
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-normal);
    text-align: center;
    padding: 0 10px;
    margin-top: 30px;
  }
  .content {
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-normal);
    padding: 20px 40px;
    .yellow {
      color: var(--color-highlight-yellow);
    }
  }
  .import {
    text-align: center;
    padding: 10px;
    .import-button {
      position: relative;
      @include hover-overlay;
      background-color: var(--color-primary);
      color: var(--color-text-on-fixed-bg);
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-bold);
      padding: 10px 60px;
      border: none;
      border-radius: var(--radius-xs);
      cursor: pointer;
    }
  }
  .skip {
    padding: 10px 10px 30px 10px;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
    color: var(--color-text-normal);
  }
}

.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.bg-white {
  background-color: var(--color-surface-subtle);
}

.overlay-fade {
  animation: fadeIn 1s ease forwards;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    fill: rgba(0, 0, 0, 0);
  }
  100% {
    opacity: 1;
    fill: rgba(0, 0, 0, 0.5);
  }
}
</style>
